module.exports = __webpack_public_path__ + "assets/img/photo_tooth_left.dc25cba0.png";